var _circle, _circle2, _circle3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoundPopupAccent = function SvgSoundPopupAccent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 164 165"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81.997,
    cy: 82.501,
    r: 62.591,
    stroke: "url(#paint0_linear_4019_20181)",
    strokeOpacity: 0.2,
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 82.5,
    r: 43,
    stroke: "url(#paint1_linear_4019_20181)",
    strokeOpacity: 0.2,
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 82.5,
    r: 81,
    stroke: "url(#paint2_linear_4019_20181)",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4019_20181",
    x1: 81.997,
    x2: 81.997,
    y1: 19.91,
    y2: 145.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505152",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4019_20181",
    x1: 82,
    x2: 82,
    y1: 39.5,
    y2: 125.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505152",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4019_20181",
    x1: 82,
    x2: 82,
    y1: 1.5,
    y2: 163.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505152",
    stopOpacity: 0.3
  })))));
};
export default SvgSoundPopupAccent;